import "./contact.scss";
import { useState, useRef } from "react";
import axios from "axios";
import React from "react";

export default function Contact({ darkMode }) {
  const [message, setMessage] = useState(false);
  const [emailCounter, setEmailCounter] = useState(0);
  const [emailCounterError, setEmailCounterError] = useState(false);
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("formRef", formRef);
    console.log("body", {
      sender_name: formRef.current[0].value,
      sender_subject: formRef.current[1].value,
      sender_email: formRef.current[2].value,
      sender_message: formRef.current[3].value,
    });
    setMessage(false);

    if (emailCounter <= 1) {
      axios
        .post("https://mohanadsafwat.pythonanywhere.com//send-email", {
          sender_name: formRef.current[0].value,
          sender_subject: formRef.current[1].value,
          sender_email: formRef.current[2].value,
          sender_message: formRef.current[3].value,
        })
        .then((r) => {
          console.log("r", r);
          setMessage(true);
          setEmailCounter((prev) => {
            return ++prev;
          });

          formRef.current[0].value = "";
          formRef.current[1].value = "";
          formRef.current[2].value = "";
          formRef.current[3].value = "";
        })
        .catch((e) => {
          console.log("e", e);
        });
    }
    else{
      setEmailCounterError(true)
    }
  };

  return (
    <div className={`contact ${darkMode ? "light" : "dark"}`} id="contact">
      <div className="left">
        <img src="assets/contact.png" alt="" />
      </div>
      <div className="right">
        <h2>Contact.</h2>
        <form ref={formRef} onSubmit={handleSubmit}>
          <input type="text" placeholder="Name" name="sender_name" required />
          <input type="text" placeholder="Subject" name="sender_subject" required />
          <input type="text" placeholder="Email" name="sender_email" required />
          <textarea placeholder="Messasge" name="sender_message" required></textarea>
          <button  type="submit">Send</button>
          {message && <span>Thanks, I'll reply ASAP</span>}
          {emailCounterError && <span style={{color: "red"}}>You have exceeded the limit</span>}
        </form>

        <a href="#about" className="arrowUp">
          <img src="assets/down.png" alt="" />
        </a>
      </div>
    </div>
  );
}
